import { decodeOrThrow } from 'app/utils/ioTs';
import { Record } from 'immutable';
import * as t from 'io-ts';
import createErrorType from 'app/utils/createErrorType';

export class OffsetMarshallerError extends createErrorType('OffsetMarshallerError') {}

const OffsetType = t.type({
  offset: t.number,
  length: t.number,
});

export type Offset = Record<t.TypeOf<typeof OffsetType>>;
// Record returns a class type, which creates a runtime variable and identifier in the namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Offset = Record<t.TypeOf<typeof OffsetType>>({
  offset: 0,
  length: 0,
});

export const OffsetMarshaller = {
  deserialize: (o: unknown): Offset => {
    const offsetData = decodeOrThrow(OffsetType, o, (errors) => {
      throw new OffsetMarshallerError(errors.join('\n'));
    });
    return new Offset(offsetData);
  },
  serialize: (offset: Offset) => offset.toJSON(),
};
